// extracted by mini-css-extract-plugin
export var card = "_kz-1";
export var summary = "_kz-0";